import '@/style/style.css';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { create } from 'naive-ui';
import App from './App.vue';
import router from './router';
import { registerComponents } from './components/register';

// Import API layer to expose window.api and window.ipcRenderer
import './api';

// Create Naive UI instance
const naiveUI = create({});

// Create Pinia store
const pinia = createPinia();

// Create Vue app
const app = createApp(App);

// Install plugins
app.use(pinia);
app.use(naiveUI);
app.use(router);

// Register global components
registerComponents(app);

// Mount app
app.mount('#app');

console.log('✅ Vinko Web Dashboard initialized');
console.log('✅ window.api available:', !!window.api);
console.log('✅ window.ipcRenderer available:', !!window.ipcRenderer);
